export { default } from "ember-router-helpers/helpers/route-params.js";
